import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

interface Data {
  status: {
    message: string;
  };
}

interface Variables {
  email: string;
  redirect: string;
  verifyWithPassword?: boolean;
}

const MUTATION = gql`
  mutation requestEmailToken(
    $email: String!
    $redirect: String!
    $verifyWithPassword: Boolean
  ) {
    status: requestEmailToken(
      email: $email
      redirect: $redirect
      verifyWithPassword: $verifyWithPassword
    ) {
      message
    }
  }
`;

export const useLoginByEmailMutation = (
  options?: useMutation.Options<Data, Variables>,
): useMutation.ResultTuple<Data, Variables> =>
  useMutation<Data, Variables>(MUTATION, options);
